import { RefObject } from "react";
import { useShallow } from "zustand/react/shallow";

import AiChatHistoryDropdown from "components/AiChat/History/Dropdown";
import { AiChatSession } from "components/AiChat/types";
import { useContainerBreakpoint } from "hooks/useContainerBreakpoint";

import { ASSISTANT_PANEL_CONTAINER } from "../../Layout/constants";
import { HISTORY_SIDE_PANEL_BREAKPOINT } from "../constants";
import useChatStore from "../store/useStore";

type AssistantPanelHistoryDropdownProps = {
  deleteChat: (chatId: string) => void;
  chats: AiChatSession[];
  loading: boolean;
  onSelectChat: (chatId: string) => void;
  boundaryRef?: RefObject<HTMLElement | null>;
};

const AssistantPanelHistoryDropdown = (props: AssistantPanelHistoryDropdownProps) => {
  const { isHistoryOpen, toggleHistory, currentChatId } = useChatStore(
    useShallow((state) => ({
      isHistoryOpen: state.isHistoryOpen,
      toggleHistory: state.toggleHistory,
      currentChatId: state.chat?.id ?? "",
    }))
  );
  const isWide = useContainerBreakpoint(ASSISTANT_PANEL_CONTAINER, HISTORY_SIDE_PANEL_BREAKPOINT);

  return (
    <AiChatHistoryDropdown
      {...props}
      currentChatId={currentChatId}
      isOpen={isHistoryOpen}
      onToggle={toggleHistory}
      showOverlay={!isWide && isHistoryOpen}
    />
  );
};

export default AssistantPanelHistoryDropdown;
